import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import MaleIcon from '../../../../icons/male.svg';
import FemaleIcon from '../../../../icons/female.svg'

import './SwitchButtons.scss';

const useStyles = makeStyles((theme) => ({
  buttonSelected: {
    borderColor: theme.palette.primary.main,
  },
  svgIcon: {
    '& > path[class*=svg]': {
      fill: theme.palette.primary.main,
    }
  }
}));

export default function SwitchButtons(props) {

  const { buttonOne, buttonTwo, selectedValue, className } = props;

  const classes = useStyles();

  return (
    <Row className={`switchButtons ${className}`}>
      <Col xs={6} className="pr-1">
        <Form.Group>
          <Button
            variant="outlined"
            className={selectedValue === buttonOne.selectedValue ? classes.buttonSelected : ''}
            startIcon={buttonOne.icon}
            id={buttonOne.name}
            onClick={buttonOne.onClick}
            fullWidth
          >
            {buttonOne.name}
          </Button>
          <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{props.error && props.error.message}</span>
        </Form.Group>
      </Col>

      <Col xs={6} className="pl-1">
        <Form.Group>
          <Button
            variant="outlined"
            className={selectedValue === buttonTwo.selectedValue ? classes.buttonSelected : ''}
            startIcon={buttonTwo.icon}
            id={buttonTwo.name}
            onClick={buttonTwo.onClick}
            fullWidth
          >
            {buttonTwo.name}
          </Button>
        </Form.Group>
      </Col>
    </Row>
  );
}

SwitchButtons.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  buttonOne: PropTypes.object.isRequired,
  buttonTwo: PropTypes.object.isRequired,
  error: PropTypes.object,
};





// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/SwitchButtons.js